const isDev = process.env.NODE_ENV === "development";
const baseDomain: any = "https://strapi.follbet.net";
const agoraChatAppKey: any = null;

// 全局系统时区配置，任何页面都可以通过 appConfig.timeZone 访问
	// 当前需求：系统时区为 UTC-3，对应巴西
const timeZoneConfig = {
  // 显示用的地区名称
  name: "秘鲁",
  // 时区偏移（小时），作为唯一真实来源，用于 dayjs.utcOffset 和展示 code 推导
  offset: -5,
  // 备用的国家代码（例如用于展示国旗）
  // countryCode: "BR",
  timeZoneIcon: "🇵🇪",
  currency:"S/.",
  currencyCode:"PEN"
};

const appConfig = {
  baseDomain: isDev ? process.env.ADMIN_DOMAIN : baseDomain,
  adminBaseURL: isDev ? process.env.ADMIN_BASE_URL : baseDomain + "/admin",
  apiBaseURL: isDev
    ? process.env.API_BASE_URL
    : baseDomain + "/user-admin-plugin",
  contentManagerApiURL: isDev
    ? process.env.ADMIN_DOMAIN + "/content-manager/collection-types"
    : baseDomain + "/content-manager/collection-types",
  contentManagerRelationsApiURL: isDev
    ? process.env.ADMIN_DOMAIN + "/content-manager/relations"
    : baseDomain + "/content-manager/relations",
  jumpToAdminUrl: isDev ? process.env.JUMP_TO_ADMIN_URL : baseDomain + "/admin",
  agoraChatAppKey: isDev ? process.env.AGORA_CHAT_APP_KEY : agoraChatAppKey,
  timeZone: timeZoneConfig,
};
export default appConfig;